// const api_xmgl = "/xxcj_dev/app_001/api_xmgl";
// const api_xxcj = "/xxcj_dev/app_001/api_xxcj";
// const api_user = "/xxcj_dev/app_001/api_user";
// const api_admin = "/xxcj_dev/app_001/api_admin";
// const api_vercode = "/xxcj_dev/app_001/api_vercode";
const api_xmgl = "/xxcj/app_001/api_xmgl";
const api_xxcj = "/xxcj/app_001/api_xxcj";
const api_user = "/xxcj/app_001/api_user";
const api_admin = "/xxcj/app_001/api_admin";
const api_vercode = "/xxcj/app_001/api_vercode";
const oem_key = "DEFAULT"
const oem_configs = {
  "ZKLS": {main_color: "#0099ff",bg_color:"#cccecc"},
  "Eastao": {main_color: "#7f7373",bg_color:"#ffffff"},
  "CT": {main_color: "#296531",bg_color:"#498484"},
  "LS": {main_color: "#c1a041",bg_color:"#686c68"},
  "DEFAULT": {main_color: "#0099ff",bg_color:"#ffffff"},
}
const subjects_name_g = [
  "语文",
  // "语文附加",
  "数学",
  // "数学附加",
  "英语",
  "物理",
  "化学",
  "生物",
  "历史",
  "地理",
  "政治",
  "音乐",
  "美术",
  "通用"
];
const subjects_name_h_g = [
  "__语文__",
  // "__语文附加__",
  "__数学__",
  // "数学附加",
  "__英语__",
  "__物理__",
  "__化学__",
  "__生物__",
  "__历史__",
  "__地理__",
  "__政治__",
  "__音乐__",
  "__美术__",
  "__通用__"
];
const subjects_g = [
  {id: "yw", name: "语文",index:0},
  {id: "sx", name: "数学",index:1},
  {id: "yy", name: "英语",index:2},
  {id: "wl", name: "物理",index:3},
  {id: "hx", name: "化学",index:4},
  {id: "sw", name: "生物",index:5},
  {id: "ls", name: "历史",index:6},
  {id: "dl", name: "地理",index:7},
  {id: "zz", name: "政治",index:8},
  {id: "ls", name: "音乐",index:9},
  {id: "dl", name: "美术",index:10},
  {id: "zz", name: "通用",index:11}
];
const subjects_header_g = [
  "__语文__",
  "__语文缺考__",
  "__语文成绩__",
  // "__语文附加__",
  // "__语文附加缺考__",
  // "__语文附加成绩__",
  "__数学__",
  "__数学缺考__",
  "__数学成绩__",
  // "__数学附加__",
  // "__数学附加缺考__",
  // "__数学附加成绩__",
  "__英语__",
  "__英语缺考__",
  "__英语成绩__",
  "__物理__",
  "__物理缺考__",
  "__物理成绩__",
  "__化学__",
  "__化学缺考__",
  "__化学成绩__",
  "__生物__",
  "__生物缺考__",
  "__生物成绩__",
  "__历史__",
  "__历史缺考__",
  "__历史成绩__",
  "__地理__",
  "__地理缺考__",
  "__地理成绩__",
  "__政治__",
  "__政治缺考__",
  "__政治成绩__",
  "__音乐__",
  "__音乐缺考__",
  "__音乐成绩__",
  "__美术__",
  "__美术缺考__",
  "__美术成绩__",
  "__通用__",
  "__通用缺考__",
  "__通用成绩__"
]
export default {
  subjects_name_h_g,
  subjects_g,
  subjects_name_g,
  subjects_header_g,
  api_xmgl,
  oem_key,
  api_xxcj,
  api_user,
  oem_configs,
  api_vercode,
  api_admin
}
